import { render, staticRenderFns } from "./itemextra.vue?vue&type=template&id=b672d182&scoped=true"
import script from "./itemextra.vue?vue&type=script&lang=js"
export * from "./itemextra.vue?vue&type=script&lang=js"
import style0 from "./itemextra.vue?vue&type=style&index=0&id=b672d182&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b672d182",
  null
  
)

export default component.exports